import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';

import SimpleLightbox from "simplelightbox";
import 'simplelightbox/dist/simple-lightbox.css';

import '../css/blocks/gallery.css'

const swipers = document.querySelectorAll('.swiper');
if (swipers) {
    swipers.forEach((element) => {
        var thumbs = parseInt(element.dataset.thumbs)
        var id = element.id.replace('swiper-', '')
        var thumbsid = "#thumbs-" + id;
        var thumbSwiper = new Swiper(thumbsid, {
            loop: true,
            spaceBetween: 10,
            slidesPerView: thumbs,
            freeMode: true,
            watchSlidesProgress: true,
        })
        var swiperid = "#swiper-" + id;
        new Swiper(swiperid, {
            modules: [Navigation, Thumbs, Pagination],
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: thumbSwiper,
            },
            pagination: {
                el: ".swiper-pagination",
                dynamicBullets: true,
                clickable: true
            },
        });
        new SimpleLightbox(swiperid + ' a.swiper-slide ', { /* options */ });
    })
}
    
//new SimpleLightbox('.swiper .swiper-slide a', { /* options */ });


//var thumbSwiper = new Swiper(".thumbswiper", {
//    loop: true,
//    spaceBetween: 10,
//    slidesPerView: 8,
//    freeMode: true,
//    watchSlidesProgress: true,
//})

//var swiper = new Swiper(".mySwiper", {
//    modules: [Navigation, Thumbs],
//    slidesPerView: 1,
//    loop: true,
//    navigation: {
//        nextEl: ".swiper-button-next",
//        prevEl: ".swiper-button-prev",
//    },
//    thumbs: {
//        swiper: thumbSwiper,
//    },
//});


//console.log('Gallery JS loaded');
